import { useContext, useMemo } from "react";
import { SettingsContext } from "../../settingsContext";
import BNHeader2022 from "./BNHeader2022";
import BNHeaderLogoOnly from "./BNHeaderLogoOnly";
import { HeaderCms, HeaderData } from "../CmsContent/services";
import { BNHeaderWithMegaMenu } from "./BNHeaderWithMegaMenu";

interface ResolveHeaderProps {
  header: HeaderCms;
  headerData: HeaderData;
  cmsContent: any;
  cmsContentOnly: boolean;
}

const ResolveHeader: React.FC<ResolveHeaderProps> = (props) => {
  const { header, headerData, cmsContent, cmsContentOnly } = props;
  const { resolveUrl, isAuthenticated } = useContext(SettingsContext);

  const otherLanguageCms = cmsContent?.otherLanguages[0];
  const otherLanguage = useMemo(() => {
    if (!otherLanguageCms) {
      return;
    }
    const { languageLabel, url, languageCode } = otherLanguageCms;
    return {
      label: languageLabel,
      url: resolveUrl(url),
      languageCode: languageCode,
    };
  }, [otherLanguageCms, resolveUrl]);

  if (cmsContentOnly || !header) {
    return null;
  }
  const headerType = cmsContent?.layoutOverrides?.headerType as "LogoOnly" | "Hidden" | undefined;
  if (headerType === "Hidden") {
    return null;
  }

  if (headerType === "LogoOnly") {
    return (
      <BNHeaderLogoOnly
        isSticky={isAuthenticated}
        transparentBg={!!header?.megaMenu?.list?.length}
        homeLink={header?.homeLink ?? headerData?.homeLink ?? "/"}
      />
    );
  }

  if (!isAuthenticated && header?.megaMenu?.list?.length) {
    return <BNHeaderWithMegaMenu isSticky header={header} otherLanguage={otherLanguage} />;
  }

  return <BNHeader2022 header={header} headerData={headerData} otherLanguage={otherLanguage} />;
};

export default ResolveHeader;
